import { create } from "zustand";

export type BreadcrumbValue =
  | string
  | {
      label: string;
      href?: string;
      editable?: boolean;
      onRename?: (nextLabel: string) => Promise<void> | void;
    };

interface LayoutState {
  breadcrumbs: Record<string, BreadcrumbValue>;

  setBreadcrumbs: (
    updater:
      | Record<string, BreadcrumbValue>
      | ((prev: Record<string, BreadcrumbValue>) => Record<string, BreadcrumbValue>),
  ) => void;
  resetBreadcrumbs: () => void;
}

export const useLayoutStore = create<LayoutState>((set) => ({
  breadcrumbs: {},

  setBreadcrumbs: (updater) =>
    set((s) => ({
      breadcrumbs: typeof updater === "function" ? updater(s.breadcrumbs) : updater,
    })),
  resetBreadcrumbs: () => set({ breadcrumbs: {} }),
}));
